import { Grid } from "@mui/material";
import NoDataImage from "./images/no-data.svg";

function NoDataFound() {
  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={1.5} sx={{ pt: 2 }}>
        <img width={210} src={NoDataImage} alt="No Data Found" />
      </Grid>
    </Grid>
  );
}

export default NoDataFound;
